import "/src/_includes/layout/base/scripts/index.js"
import "/src/_includes/sections/questions-section/scripts/index.js"
import "/src/_includes/sections/download-section/scripts/index.js"
import "/src/_includes/sections/features-section-new/scripts/index.js"
import "/src/_includes/sections/reviews-section/scripts/index.js"

import "/src/scripts/rebuild/slider.js"

// import calc from './calc.js'
import chart from './ticker-chart.js'
import tickerSlider from './ticker-slider.js'
import videoSlider from './exchange-video-slider.js'
import buyOptionsSlider from './buy-options-slider.js'
import cryptoTable from './crypto-table.js'

import '../styles/index.scss'


// calc()
chart()
tickerSlider()
videoSlider()
buyOptionsSlider()
cryptoTable()


//ticker coins data
document.querySelectorAll('.ticker').forEach(item => renderBlock(item))

function renderBlock(item, defaultCoin) {
	let short = defaultCoin || item.querySelector('.ticker__name--short').innerText
	if(short === "USDTERC20" || short === "USDTTRC20") {
		short = "USDT"
	}
	let priceEl = item.querySelector('.ticker__price')
	let changeEl = item.querySelector('.ticker__change-data')

	fetch(`https://raki.atomicwallet.io/pricemultifull?tsyms=USD&fsyms=${short}`)
		.then(data => {
			return data.json()
		})
		.then(data => {
			let price = data.RAW[short].USD.PRICE.toFixed(2)
			let change = data.RAW[short].USD.CHANGEPCT24HOUR.toFixed(2)
			let plus = ''

			if (change[0] !== '-') plus = '+'

			priceEl.innerText = '$' + price
			changeEl.innerText = plus + change + '%'
		})
		.catch(err => {
			console.warn(err)
			console.log(short)

			item.querySelector('.ticker__name').innerText = 'Bitcoin'
			item.querySelector('.ticker__icon').classList.add('icon', 'icon-btc')

			renderBlock(item, "BTC")
		})
}

//video button for youtube
// let video = document.querySelector('.exchange__video')
// let buttons = document.querySelectorAll('.exchange-button--play')
// let fade = document.querySelector('.exchange__video-fade')
// buttons.forEach(function(item) {
// 	item.addEventListener('click', function(event) {
// 		let src = this.getAttribute('data-src')
// 		if (fade.classList.contains('active')) return
// 		video.src = src
// 		fade.classList.add('active')
// 	})
// })
// fade.addEventListener('click', function() {
// 	this.classList.remove('active')
// 	video.setAttribute('src', '')
// })

//zoom
// let image = document.querySelector('.exchange__image')
// let imgs = document.querySelectorAll('.section-5__img')
// let imgFade = document.querySelector('.exchange__img-fade')
// imgs.forEach(function(item) {
//     item.addEventListener('click', function() {
//         let src;
//         if(window.innerWidth >= 450) {
//             src = this.getAttribute('data-full-img')
//         } else {
//             src = this.src
//         }
//         if (imgFade.classList.contains('active')) return
//         image.src = src
//         imgFade.classList.add('active')
//     })
// })
// imgFade.addEventListener('click', function() {this.classList.remove('active')})